import { StatusContainer } from "./style";

interface IProps {
  status: "PROCESSANDO" | "ERRO" | "CONCLUIDO";
  width?: string;
}

export function StatusItemLoteBloqueio({ status, width }: IProps) {
  const strategy = {
    PROCESSANDO: {
      texto: "Processando",
      backgroundColor: "#F2F2F2",
      color: "#6E6E6E",
      border: "1px solid #6E6E6E",
    },
    ERRO: {
      texto: "Erro",
      backgroundColor: "#FFE4E4",
      color: "#EE5353",
      border: "1px solid #EE5353",
    },
    CONCLUIDO: {
      texto: "Concluído",
      backgroundColor: "#E6F9F0",
      color: "#2EAD65",
      border: "1px solid #2EAD65",
    },
  };

  const statusConfig = strategy[status];

  return (
    <StatusContainer width={width} style={statusConfig}>
      {statusConfig.texto}
    </StatusContainer>
  );
}
